import { PauseIcon, PlayIcon, StopIcon } from "@heroicons/react/outline";
import dayjs from "dayjs";
import duration, { Duration } from "dayjs/plugin/duration";
import type { NextPage } from "next";
import { useEffect, useState } from "react";
import ClockEmployeeSearch from "../components/ClockEmployeeSearch";
import Layout from "../components/Layout";
import NotInPlanningModal from "../components/NotInPlanningModal";
import useStore from "../store/store";
import { IWorkTime } from "../types/worktime";

const ClockPage: NextPage = () => {
  const {
    employees,
    setActiveTimeEmployee,
    activeTimeEmployee,
    addWorktime,
    worktimes,
    updateWorktime,
    allocations,
    myCompany,
    setLoading,
    loading,
  } = useStore();

  const [activeEmployeeTimer, setActiveEmployeeTimer] =
    useState<IWorkTime | null>(null);
  const [workedHours, setWorkedHours] = useState(0);
  const [employeesAllocationId, setEmployeesAllocationId] = useState("");
  const [isInTodayPlanning, setIsInTodayPlanning] = useState(false);

  useEffect(() => {
    const todayWorktimes = worktimes.filter(
      (worktime) =>
        new Date().setHours(0, 0, 0, 0) ===
        new Date(parseInt(worktime.shiftStart)).setHours(0, 0, 0, 0)
    );

    const employeeTodayWorktime = todayWorktimes.filter(
      (worktime) => worktime.employeeId === activeTimeEmployee?._id
    );

    setActiveEmployeeTimer(employeeTodayWorktime[0]);

    if (activeEmployeeTimer !== null && activeEmployeeTimer !== undefined) {
      console.log("active employee timer object", activeEmployeeTimer);

      const startShift = dayjs(parseInt(activeEmployeeTimer.shiftStart));
      const endShift = dayjs(parseInt(activeEmployeeTimer.shiftEnd));

      const shiftLength = endShift.diff(startShift);

      const startPause =
        activeEmployeeTimer.pauseStart !== ""
          ? dayjs(parseInt(activeEmployeeTimer.pauseStart))
          : null;
      const endPause =
        activeEmployeeTimer.pauseEnd !== ""
          ? dayjs(parseInt(activeEmployeeTimer.pauseEnd))
          : null;

      if (startPause !== null && endPause !== null) {
        const pauseLength = endPause.diff(startPause);

        console.log(
          "shift length",
          `${dayjs.duration(shiftLength).hours()} : ${dayjs
            .duration(shiftLength)
            .minutes()} : ${dayjs.duration(shiftLength).seconds()}`
        );

        console.log(
          "pause length",
          `${dayjs.duration(pauseLength).hours()} : ${dayjs
            .duration(pauseLength)
            .minutes()} : ${dayjs.duration(pauseLength).seconds()}`
        );

        const workedHoursRes = dayjs(shiftLength).diff(pauseLength);
        setWorkedHours(workedHoursRes);
      } else {
        setWorkedHours(shiftLength);
      }
    }
    const todaysAllocations = allocations.filter(
      (alloc) =>
        alloc.employeeId === activeTimeEmployee?._id &&
        alloc.date === new Date().toISOString().split("T")[0] &&
        alloc.status === "available"
    );
    if (todaysAllocations.length > 0) {
      setEmployeesAllocationId(todaysAllocations[0]?._id?.toString() || "");
      setIsInTodayPlanning(true);
    } else {
      setEmployeesAllocationId("");
      setIsInTodayPlanning(false);
    }
  }, [activeEmployeeTimer, activeTimeEmployee, worktimes]);

  useEffect(() => {
    dayjs.extend(duration);
  }, []);

  return (
    <div className="constainer">
      {loading && (
        <div className="bg-background-transparent fixed flex h-full items-center justify-center opacity-50 w-full z-10 cursor-wait"></div>
      )}
      <NotInPlanningModal
        employeeName={`${activeTimeEmployee?.firstName} ${activeTimeEmployee?.lastName}`}
      ></NotInPlanningModal>
      <div className="w-fit h-fit mx-auto mt-28">
        <ClockEmployeeSearch
          companyName={
            myCompany?.includes("#") ? myCompany.split("#")[1] : myCompany
          }
          companyEmployees={employees}
        ></ClockEmployeeSearch>

        {activeTimeEmployee &&
          (activeEmployeeTimer === null || activeEmployeeTimer === undefined) &&
          isInTodayPlanning && (
            <div className="flex items-center justify-center mt-28">
              <div className="flex flex-col text-bright-green">
                <button
                  className="rounded-full mb-4 disabled:opacity-50"
                  title="Start tijdsregistratie"
                  onClick={async (e) => {
                    //@ts-ignore
                    e.target.disabled = true;

                    const shiftStart = +new Date();
                    console.log("shift start", shiftStart);

                    const worktime: IWorkTime = {
                      _id: null,
                      shiftStart: shiftStart.toString(),
                      shiftEnd: "",
                      pauseStart: "",
                      pauseEnd: "",
                      employeeId: activeTimeEmployee._id!,
                      allocationId: employeesAllocationId,
                      note: "",
                    };

                    addWorktime(worktime);
                  }}
                >
                  <PlayIcon
                    className="pointer-events-none"
                    width={80}
                  ></PlayIcon>
                </button>
                <p className="font-bold text-center text-base">Start</p>
              </div>
            </div>
          )}

        {activeTimeEmployee &&
          activeEmployeeTimer !== null &&
          activeEmployeeTimer !== undefined &&
          isInTodayPlanning && (
            <div className="flex justify-around items-center mt-28">
              {activeEmployeeTimer.pauseStart === "" &&
                activeEmployeeTimer.pauseEnd === "" &&
                activeEmployeeTimer.shiftEnd === "" && (
                  <div className="flex flex-col text-center text-blue text-xs">
                    <button
                      className="rounded-full mb-4 disabled:opacity-50"
                      title="Pauzeer tijdsregistratie"
                      onClick={(e) => {
                        //@ts-ignore
                        e.target.disabled = true;

                        const pauseStart = +new Date();
                        console.log("pause start", pauseStart);

                        const worktime: IWorkTime = {
                          _id: activeEmployeeTimer._id,
                          shiftStart: activeEmployeeTimer.shiftStart,
                          shiftEnd: activeEmployeeTimer.shiftEnd,
                          pauseStart: pauseStart.toString(),
                          pauseEnd: "",
                          employeeId: activeTimeEmployee._id!,
                          allocationId: employeesAllocationId,
                          note: "",
                        };

                        updateWorktime(worktime);
                      }}
                    >
                      <PauseIcon
                        className="pointer-events-none"
                        height={80}
                      ></PauseIcon>
                    </button>
                    <p className="font-bold text-center text-base">Pauze</p>
                  </div>
                )}

              {activeEmployeeTimer.pauseStart !== "" &&
                activeEmployeeTimer.pauseEnd === "" && (
                  <div className="flex flex-col text-center text-bright-green text-xs">
                    <button
                      className="rounded-full mb-4 disabled:opacity-50"
                      title="Hervat tijdsregistratie"
                      onClick={(e) => {
                        //@ts-ignore
                        e.target.disabled = true;

                        const pauseEnd = +new Date();
                        console.log("pause end", pauseEnd);

                        const worktime: IWorkTime = {
                          _id: activeEmployeeTimer._id,
                          shiftStart: activeEmployeeTimer.shiftStart,
                          shiftEnd: activeEmployeeTimer.shiftEnd,
                          pauseStart: activeEmployeeTimer.pauseStart,
                          pauseEnd: pauseEnd.toString(),
                          employeeId: activeTimeEmployee._id!,
                          allocationId: employeesAllocationId,
                          note: "",
                        };

                        updateWorktime(worktime);
                      }}
                    >
                      <PlayIcon
                        className="pointer-events-none"
                        height={80}
                      ></PlayIcon>
                    </button>
                    <p className="font-bold text-center text-base">Hervatten</p>
                  </div>
                )}

              {activeEmployeeTimer.shiftEnd === "" &&
                activeEmployeeTimer.pauseStart === "" &&
                activeEmployeeTimer.pauseEnd === "" && (
                  <div className="flex flex-col text-center text-red text-xs">
                    <button
                      className="rounded-full mb-4 disabled:opacity-50"
                      title="Stop tijdsregistratie"
                      onClick={(e) => {
                        //@ts-ignore
                        e.target.disabled = true;

                        const shiftEnd = +new Date();
                        console.log("shift end", shiftEnd);

                        const worktime: IWorkTime = {
                          _id: activeEmployeeTimer._id,
                          shiftStart: activeEmployeeTimer.shiftStart.toString(),
                          shiftEnd: shiftEnd.toString(),
                          pauseStart: activeEmployeeTimer.pauseStart.toString(),
                          pauseEnd: activeEmployeeTimer.pauseEnd.toString(),
                          employeeId: activeTimeEmployee._id!,
                          allocationId: employeesAllocationId,
                          note: "",
                        };

                        updateWorktime(worktime);
                      }}
                    >
                      <StopIcon
                        className="pointer-events-none"
                        height={80}
                      ></StopIcon>
                    </button>
                    <p className="font-bold text-center text-base">Stop</p>
                  </div>
                )}

              {activeEmployeeTimer.shiftEnd === "" &&
                activeEmployeeTimer.pauseStart !== "" &&
                activeEmployeeTimer.pauseEnd !== "" && (
                  <div className="flex flex-col text-center text-red text-xs">
                    <button
                      className="rounded-full mb-4 disabled:opacity-50"
                      title="Stop tijdsregistratie"
                      onClick={(e) => {
                        //@ts-ignore
                        e.target.disabled = true;

                        const shiftEnd = +new Date();
                        console.log("shift end", shiftEnd);

                        const worktime: IWorkTime = {
                          _id: activeEmployeeTimer._id,
                          shiftStart: activeEmployeeTimer.shiftStart.toString(),
                          shiftEnd: shiftEnd.toString(),
                          pauseStart: activeEmployeeTimer.pauseStart.toString(),
                          pauseEnd: activeEmployeeTimer.pauseEnd.toString(),
                          employeeId: activeTimeEmployee._id!,
                          allocationId: employeesAllocationId,
                          note: "",
                        };

                        updateWorktime(worktime);
                      }}
                    >
                      <StopIcon
                        className="pointer-events-none"
                        height={80}
                      ></StopIcon>
                    </button>
                    <p className="font-bold text-center text-base">Stop</p>
                  </div>
                )}

              {activeEmployeeTimer.shiftEnd !== "" && (
                <div>
                  <p className="text-center">Gepresteerde uren</p>
                  <p className="text-center text-sm font-bold">
                    {dayjs.duration(workedHours).hours() < 10
                      ? `0${dayjs.duration(workedHours).hours()}`
                      : dayjs.duration(workedHours).hours()}{" "}
                    :{" "}
                    {dayjs.duration(workedHours).minutes() < 10
                      ? `0${dayjs.duration(workedHours).minutes()}`
                      : dayjs.duration(workedHours).minutes()}{" "}
                    :{" "}
                    {dayjs.duration(workedHours).seconds() < 10
                      ? `0${dayjs.duration(workedHours).seconds()}`
                      : dayjs.duration(workedHours).seconds()}
                  </p>
                </div>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

export default ClockPage;
